<template>
  <!--首页Logo-->
  <div class="all-class">
    <!--:src="'data:image/png;base64,'+logoImage"-->
    <div class="logo-class">
      <img src="../image/logo.png" class="img-logo-class" @click="toHome()"/>
      <div class="show-class">
        <span>
          山东康成尔兴药业集团有限公司
        </span>
      </div>
      <div class="div-show-class">
        <img src="../image/customer.png" class="img-show-class" @click="toContact()"/>
        <img src="../image/telephone.jpg" class="img-show-class " @click="toContact()"/>
        <img src="../image/address.png" class="img-show-class" @click="toMap()"/>
        <!--          <img src="../image/logo2.png" class="img-show-class"/>-->
      </div>
<!--      <div class="input-logo-class">-->
<!--        <el-input placeholder="请输入内容" v-model="selVal">-->
<!--        </el-input>-->
<!--      </div>-->
<!--      <div>-->
<!--        <el-button slot="append" icon="el-icon-search" type="primary"></el-button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      selVal:""
    }
  },
  methods:{
    toHome(){
      this.$router.push("/home");
    },
    toContact(){
      this.$router.push("/contact");
    },
    toMap(){
      this.$router.push("/map");
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
.all-class{
  width: 100%;
}

.logo-class{
  height: 90px;
  line-height: 90px;
  display: flex;
  margin-left: 10%;
  width: 80%;
}


.img-logo-class{
  height: 90px;
  margin-top: 10px;
  position: relative;
  /*margin-left: 10%;*/
  display: flex;
  width: 70px;
  height: 70px;
  cursor: pointer;
}
.input-logo-class{
  width: 400px;
  margin-left: 16%;
}

.show-class{
  font-size: 50px;
  font-family: cursive;
  font-weight: bolder;
  display: flex;
}
.show-class>span{
  float: left;
}
.div-show-class{
  all:initial;
  margin-left: auto;
}
.img-show-class{
  margin-top: 10px;
  position: relative;
  width: 70px;
  height: 70px;
  padding-left: 25px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/component/LogoHome.vue